import React, { useEffect, useState } from 'react';
import LoaderImage from '../../../assets/icons/Splash_screen_loader.gif';

interface LoaderProps {
  insetToZero?: boolean;
  fullScreen?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ insetToZero = false, fullScreen = false }) => {
  const [loaderClassName, setClassName] = useState<string>('');

  useEffect(() => {
    if (insetToZero) {
      setClassName('inset-0');
    } else {
      setClassName('inset-initial');
    }
  }, [insetToZero]);

  const loaderClass = fullScreen ? 'full-screen' : loaderClassName;

  return (
    <div className={`${loaderClass} loader-wrapper`} aria-label="loading">
      <img src={LoaderImage} alt="Loading..." className="loader-img" />
    </div>
  );
};

export default Loader;
